// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"9756ee1f","318":"5f2cc378","453":"99798bf3"}[chunkId] + ".chunk.js";
};